import { ApiError } from './errors';

export interface FetchResult<TData> {
  data?: TData;
  error?: unknown;
  response: Response;
}

/**
 * Narrows an openapi-fetch result to its success payload.
 * Throws ApiError for any non-2xx response or missing data.
 *
 * Exists because several list endpoints declare only `200` in OpenAPI —
 * openapi-fetch then types `error` as `undefined`, making `result.error`
 * checks collapse to `never`. This helper bypasses that quirk.
 */
export const unwrap = <TData>(result: FetchResult<TData>): TData => {
  if (!result.response.ok || result.data === undefined) {
    const errBody = (result.error ?? {}) as { error?: string };
    throw new ApiError(result.response.status, errBody.error ?? 'fetch_failed');
  }
  return result.data;
};
